/**
 * @see mockMd/union_city_war_groups.md
 */
import {storiesUnionAvatar} from '../components/NoOwnGroupRank/stories-images'
import {storiesAvatar} from '../components/OtherZonesDrawer/stories-images'
import {
  UnionCityWarStage,
  type UnionCityWarGroupUnionItem,
  type UnionCityWarGroupsData,
} from '../types'

/** 无分组榜 Mock 头像 · 对齐 state-default 羊头 */
export const MOCK_NO_OWN_UNION_AVATAR = storiesUnionAvatar

const MOCK_USER_AVATAR = storiesAvatar

const mkNoOwnItem = (
  rank: number,
  unionId: number
): UnionCityWarGroupUnionItem => ({
  rank,
  union_id: unionId,
  union_avatar: MOCK_NO_OWN_UNION_AVATAR,
  union_name: 'USER NAME US...',
  city_score: 300000,
})

const mkNoOwnGroup = (groupNo: number): UnionCityWarGroupUnionItem[] =>
  Array.from({length: 6}, (_, i) =>
    mkNoOwnItem(i + 1, 100001 + (groupNo - 1) * 10 + i)
  )

const mkItem = (rank: number): UnionCityWarGroupUnionItem => ({
  rank,
  union_id: 100001,
  union_avatar: MOCK_USER_AVATAR,
  union_name: 'USER NAME US...',
  city_score: 300000,
})

const mkTop6 = (): UnionCityWarGroupUnionItem[] =>
  [1, 2, 3, 4, 5, 6].map(mkItem)

/** @see mockMd/union_city_war_groups.md · 对齐其他生存区战况半屏-常态 2 区 × Top6 */
export const UnionCityWarGroupsMock: UnionCityWarGroupsData = {
  err_msg: '',
  stage: UnionCityWarStage.Final,
  own_group: 1,
  groups: {
    1: mkTop6(),
    2: mkTop6(),
  },
}

/**
 * 用户无分组（own_group=0）默认 VRT
 * 对齐 tasks-docs/user-no-group-rank/images/state-default.png
 * 可见：4 张生存区卡 × 每卡 Top6
 */
export const UnionCityWarGroupsNoOwnMock: UnionCityWarGroupsData = {
  err_msg: '',
  stage: UnionCityWarStage.Group,
  own_group: 0,
  groups: {
    1: [],
    2: mkNoOwnGroup(2),
    3: mkNoOwnGroup(3),
    4: mkNoOwnGroup(4),
  },
}

/** 单卡空态 · 对齐 state-empty.png */
export const UnionCityWarGroupsEmptyZoneMock: UnionCityWarGroupsData = {
  err_msg: '',
  stage: UnionCityWarStage.Group,
  own_group: 0,
  groups: {
    1: [],
  },
}
